import React from 'react';
import '../styles/Services.css';

function Services({ language }) {

  // Platforms (updated positioning: Integration + Automation + AI ecosystem)
  const platforms = [
    {
      id: 1,
      name: 'Salesforce',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/f/f9/Salesforce.com_logo.svg',
      descEN: 'Leading CRM platform enabling organizations to manage customer relationships, sales, and service operations at scale.',
      descFR: 'Plateforme CRM leader permettant de gérer les relations clients, les ventes et les services à grande échelle.',
      features: [
        { en: 'CRM & Sales Automation', fr: 'CRM & automatisation des ventes' },
        { en: 'Service & Experience Cloud', fr: 'Service & Experience Cloud' },
        { en: 'Process Automation', fr: 'Automatisation des processus' },
        { en: 'Enterprise Ecosystem Integration', fr: 'Intégration écosystème entreprise' }
      ]
    }, {
      id: 2,
      name: 'AI Solutions (Anthropic Partnership)',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/7/78/Anthropic_logo.svg',
      descEN: 'AI-powered solutions leveraging advanced models to automate decisions, optimize workflows, and enable intelligent business processes.',
      descFR: 'Solutions basées sur l’IA exploitant des modèles avancés pour automatiser les décisions, optimiser les workflows et créer des processus intelligents.',
      features: [
        { en: 'AI Automation', fr: 'Automatisation IA' },
        { en: 'Intelligent Workflows', fr: 'Workflows intelligents' },
        { en: 'Data Insights', fr: 'Analyse de données' },
        { en: 'LLM Integration', fr: 'Intégration LLM' }
      ]
    },
    {
      id: 3,
      name: 'Celigo',
      logo: 'https://www.celigo.com/wp-content/uploads/2024/04/celigo-logo.png',
      descEN: 'Integration platform (iPaaS) that connects applications and automates business processes with prebuilt solutions.',
      descFR: 'Plateforme d’intégration (iPaaS) connectant les applications et automatisant les processus métier avec des solutions prêtes à l’emploi.',
      features: [
        { en: 'iPaaS Integration', fr: 'Intégration iPaaS' },
        { en: 'Prebuilt Connectors', fr: 'Connecteurs prêts à l’emploi' },
        { en: 'Data Synchronization', fr: 'Synchronisation des données' },
        { en: 'Process Automation', fr: 'Automatisation des processus' }
      ]
    },
   
    {
      id: 4,
      name: 'Workato',
      logo: 'https://raw.githubusercontent.com/Helmifalfie7/nexofortis/main/logodynamics/workato.png',
      descEN: 'Low-code automation platform to orchestrate workflows and integrate enterprise applications efficiently.',
      descFR: 'Plateforme low-code permettant d’orchestrer les workflows et d’intégrer les applications d’entreprise efficacement.',
      features: [
        { en: 'Workflow Automation', fr: 'Automatisation des workflows' },
        { en: '1000+ Connectors', fr: '1000+ connecteurs' },
        { en: 'Process Orchestration', fr: 'Orchestration des processus' },
        { en: 'Low-Code Integration', fr: 'Intégration low-code' }
      ]
    }
  ];

  // Services (repositioned: Integration / Automation / AI)
  const services = [
    {
      id: 1,
      icon: 'fa-plug',
      titleEN: 'Integration & API Services',
      titleFR: 'Services d’Intégration & API',
      descEN: 'Connect systems, applications, and data through scalable and secure integration architectures.',
      descFR: 'Connectez les systèmes, applications et données via des architectures d’intégration scalables et sécurisées.',
      forWhoEN: 'Enterprises with complex and distributed systems',
      forWhoFR: 'Entreprises avec des systèmes complexes et distribués',
      outcomesEN: [
        'Faster system connectivity',
        'Real-time data flow',
        'Reusable integration assets'
      ],
      outcomesFR: [
        'Connexion système plus rapide',
        'Flux de données en temps réel',
        'Composants réutilisables'
      ],
      includedEN: [
        'Integration architecture design',
        'API development & implementation',
        'System connectivity setup',
        'Testing & deployment'
      ],
      includedFR: [
        'Conception d’architecture d’intégration',
        'Développement & implémentation API',
        'Mise en place des connexions systèmes',
        'Tests & déploiement'
      ]
    },
    {
      id: 2,
      icon: 'fa-robot',
      titleEN: 'Automation & RPA Solutions',
      titleFR: 'Automatisation & Solutions RPA',
      descEN: 'Automate business processes and repetitive tasks using low-code platforms and RPA technologies.',
      descFR: 'Automatisez les processus métier et tâches répétitives grâce aux plateformes low-code et technologies RPA.',
      forWhoEN: 'Operations teams looking to eliminate manual work',
      forWhoFR: 'Équipes opérationnelles souhaitant éliminer les tâches manuelles',
      outcomesEN: [
        'Reduced manual workload',
        'Higher operational efficiency',
        'Improved accuracy'
      ],
      outcomesFR: [
        'Réduction des tâches manuelles',
        'Meilleure efficacité opérationnelle',
        'Amélioration de la précision'
      ],
      includedEN: [
        'Process mapping & analysis',
        'Automation implementation',
        'RPA deployment (UiPath, Blue Prism, MuleSoft RPA)',
        'Continuous optimization'
      ],
      includedFR: [
        'Cartographie et analyse des processus',
        'Implémentation des automatisations',
        'Déploiement RPA (UiPath, Blue Prism, MuleSoft RPA)',
        'Optimisation continue'
      ]
    },
    {
      id: 3,
      icon: 'fa-brain',
      titleEN: 'AI & Intelligent Automation',
      titleFR: 'IA & Automatisation Intelligente',
      descEN: 'Leverage AI to enhance decision-making, automate complex workflows, and unlock intelligent business processes.',
      descFR: 'Exploitez l’IA pour améliorer la prise de décision, automatiser des workflows complexes et activer des processus intelligents.',
      forWhoEN: 'Organizations scaling with AI and data-driven transformation',
      forWhoFR: 'Organisations en transformation vers l’IA et la donnée',
      outcomesEN: [
        'Smarter decision-making',
        'AI-powered automation',
        'Data-driven insights'
      ],
      outcomesFR: [
        'Décisions plus intelligentes',
        'Automatisation par IA',
        'Insights basés sur les données'
      ],
      includedEN: [
        'AI use case design',
        'LLM integration (Anthropic)',
        'Intelligent workflow design',
        'AI automation implementation'
      ],
      includedFR: [
        'Conception de cas d’usage IA',
        'Intégration LLM (Anthropic)',
        'Conception de workflows intelligents',
        'Implémentation d’automatisation IA'
      ]
    }
  ];

  return (
    <section id="services" className="services-section">
      <div className="container">

        {/* PLATFORM SECTION */}
        <div className="platforms-section">
          <h2 className="section-title">
            <span lang="en">Our Technology Ecosystem</span>
            <span lang="fr">Notre Écosystème Technologique</span>
          </h2>

          <p className="section-subtitle">
            <span lang="en">
              We operate across leading platforms in integration, automation, and AI to deliver scalable digital transformation
            </span>
            <span lang="fr">
              Nous opérons sur les principales plateformes d’intégration, d’automatisation et d’IA pour livrer des transformations digitales scalables
            </span>
          </p>

          <div className="platforms-grid">
            {platforms.map((platform) => (
              <div key={platform.id} className="platform-card">
                <div className="platform-logo">
                  <img src={platform.logo} alt={platform.name} />
                </div>

                <h3>{platform.name}</h3>

                <p className="platform-description">
                  <span lang="en">{platform.descEN}</span>
                  <span lang="fr">{platform.descFR}</span>
                </p>

                <div className="platform-features">
                  {platform.features.map((feature, idx) => (
                    <div key={idx} className="feature-badge">
                      <span lang="en">{feature.en}</span>
                      <span lang="fr">{feature.fr}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* SERVICES SECTION */}
        <div className="detailed-services-section">
          <h2 className="section-title">
            <span lang="en">Integration, Automation & AI Solutions</span>
            <span lang="fr">Intégration, Automatisation & Solutions IA</span>
          </h2>

          <p className="section-subtitle">
            <span lang="en">
              We design and deliver end-to-end digital transformation solutions combining integration, automation, and AI
            </span>
            <span lang="fr">
              Nous concevons et livrons des solutions de transformation digitale combinant intégration, automatisation et IA
            </span>
          </p>

          <div className="services-grid-detailed">
            {services.map((service) => (
              <div key={service.id} className="service-card-detailed">

                <div className="service-header">
                  <div className="service-icon-large">
                    <i className={`fas ${service.icon}`}></i>
                  </div>

                  <h3>
                    <span lang="en">{service.titleEN}</span>
                    <span lang="fr">{service.titleFR}</span>
                  </h3>
                </div>

                <p className="service-description">
                  <span lang="en">{service.descEN}</span>
                  <span lang="fr">{service.descFR}</span>
                </p>

                <div className="service-section">
                  <h4>
                    <span lang="en">Who It's For</span>
                    <span lang="fr">Pour Qui</span>
                  </h4>
                  <p>
                    <span lang="en">{service.forWhoEN}</span>
                    <span lang="fr">{service.forWhoFR}</span>
                  </p>
                </div>

                <div className="service-section">
                  <h4>
                    <span lang="en">Business Outcomes</span>
                    <span lang="fr">Résultats Métier</span>
                  </h4>

                  <ul>
                    {service.outcomesEN.map((outcome, idx) => (
                      <li key={idx}>
                        <span lang="en">{outcome}</span>
                        <span lang="fr">{service.outcomesFR[idx]}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="service-section">
                  <h4>
                    <span lang="en">What's Included</span>
                    <span lang="fr">Ce qui est inclus</span>
                  </h4>

                  <ul>
                    {service.includedEN.map((item, idx) => (
                      <li key={idx}>
                        <span lang="en">{item}</span>
                        <span lang="fr">{service.includedFR[idx]}</span>
                      </li>
                    ))}
                  </ul>
                </div>

              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}

export default Services;